var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('canvas',{ref:"diagramCanvas"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }